module.exports = __webpack_public_path__ + "static/fabric-style-3-fe52ed05e8e5d0d23a97687338d8eef7.png";